/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Buttons.module.css';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

// button with text and value
class SimpleBtn extends Component {
  render() {
    const obj = this.props.obj;
    const selected = this.props.active;

    let classes = `${styles.input} ${styles.sized}`;
    classes += selected ? ` ${styles.selected}` : '';
    return (
      <button
        className={`${classes}`}
        type="button"
        value={obj.value}
        disabled={this.props.disabled}
        onClick={() => this.props.onClick(obj.value)}
      >
        <span>{obj.text}</span>
      </button>
    );
  }
}

SimpleBtn.defaultProps = {
  disabled: false,
  selected: false,
};

export default SimpleBtn;
